unit UKstModel;

interface

uses
  Js;

type
  TKstModel = class
  private
    FBezeichnung: string;
    FId: Integer;
    FNr: string;
    procedure SetBezeichnung(const Value: string);
    procedure SetId(const Value: Integer);
    procedure SetNr(const Value: string);
  public
    constructor Create; overload;
    constructor Create(json: string); overload;
    function ToJson: string;
    function ToString: string; override;
    procedure ClearValues;
    procedure SetValues(json: string); overload;
    procedure SetValues(obj: TJsObject); overload;
    property Id: Integer read FId write SetId;
    property Nr: string read FNr write SetNr;
    property Bezeichnung: string read FBezeichnung write SetBezeichnung;
  end;

implementation

uses
  System.SysUtils, WebLib.JSON, UEssentialHelper;

{ TKstModel }

procedure TKstModel.ClearValues;
begin
  Self.Id := 0;
  Self.Nr := '';
  Self.Bezeichnung := '';
end;

constructor TKstModel.Create;
begin
  Self.ClearValues;
end;

constructor TKstModel.Create(json: string);
begin
  Self.SetValues(json);
end;

procedure TKstModel.SetBezeichnung(const Value: string);
begin
  FBezeichnung := Value;
end;

procedure TKstModel.SetId(const Value: Integer);
begin
  FId := Value;
end;

procedure TKstModel.SetNr(const Value: string);
begin
  FNr := Value;
end;

procedure TKstModel.SetValues(obj: TJsObject);
begin
  Self.ClearValues;
  if obj['Id'] <> nil then
    Self.Id := StrToInt(string(obj['Id']));
  if obj['Nr'] <> nil then
    Self.Nr := string(obj['Nr']);
  if obj['Bezeichnung'] <> nil then
    Self.Bezeichnung := string(obj['Bezeichnung']);
end;

function TKstModel.ToJson: string;
var
  obj: TJsonObject;
begin
  obj := TJsonObject.Create;
  obj.AddPair('Id', IntToStr(Self.Id));
  obj.AddPair('Nr', Self.Nr);
  obj.AddPair('Bezeichnung', Self.Bezeichnung);
  Result := obj.ToString;
end;

function TKstModel.ToString: string;
begin
  Result := Self.Nr + #9 + Self.Bezeichnung;
end;

procedure TKstModel.SetValues(json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

end.
